<script setup lang="ts">
    import { Chart } from 'highcharts-vue';
    import Highcharts from 'highcharts';
    // import 'highcharts/modules/accessibility';
    import { onMounted, ref } from 'vue';
    import { useNotifyParentOnUpdate } from '@/js/composables/useWidgetUpdated';

    const props = defineProps<{
        data: object;
    }>();

    const options = ref<Highcharts.Options | null>(null);

    onMounted(async () => {
        options.value = props.data as Highcharts.Options;
    });

    useNotifyParentOnUpdate(options);
</script>

<template>
    <div class="w-lg max-w-full">
        <Chart v-if="options" style="height: 100%" :options="options" :highcharts="Highcharts" />
    </div>
</template>
